import { displayedStatus } from './status/expiryHelpers';

// Contract: token identifier the sibling Delete action-surface story emits.
export const DELETE_ACTION = 'DELETE';

// Gate outcome reason codes.
export const GATE_OK = null;
export const GATE_NOT_VSC = 'not-vsc';
export const GATE_NOT_REVOKED = 'not-revoked';
export const GATE_INCOMPLETE_DATA = 'incomplete-data';

export const isVsc = (device) => device?.subType === 'vsc';

export const isSmartcard = (device) => device?.type === 'smartcard';

// A stored 'revoked' status is terminal and must win over the dynamic 'expired'
// display overlay: a revoked card is revoked even after its cert passes end-validity.
export const isRevoked = (device) => {
    if ((device?.status || '').toLowerCase() === 'revoked') {
        return true;
    }
    return (displayedStatus(device) || '').toLowerCase() === 'revoked';
};

// "Present status" is the STORED device.status (the authoritative signal isRevoked keys on),
// not displayedStatus(device): displayedStatus returns 'expired' from cert end-validity even
// when the stored status is missing/non-string, which would let an unresolved device pass
// completeness and be mislabeled 'not-revoked' instead of 'incomplete-data'.
export const hasCompleteTargetData = (device) =>
    !!device &&
    typeof device.serial === 'string' &&
    device.serial.length > 0 &&
    typeof device.type === 'string' &&
    device.type.length > 0 &&
    typeof device.status === 'string' &&
    device.status.length > 0;

// Single source of truth for whether the gated Delete action may proceed.
// Reason precedence guarantees exactly one outcome per device.
export const evaluateGatedAction = (device) => {
    if (!isVsc(device)) {
        return { ok: false, reason: GATE_NOT_VSC };
    }
    if (!hasCompleteTargetData(device) || !isSmartcard(device)) {
        return { ok: false, reason: GATE_INCOMPLETE_DATA };
    }
    if (!isRevoked(device)) {
        return { ok: false, reason: GATE_NOT_REVOKED };
    }
    return { ok: true, reason: GATE_OK };
};
